var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageDucEditorResetMobile = function SvgImageDucEditorResetMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.107.41a.6.6 0 0 1 .484.696L16.78 5.6h-5.137a.6.6 0 0 1 0-1.2h3.488a7.644 7.644 0 0 0-5.944-2.8C4.984 1.6 1.6 4.926 1.6 9s3.384 7.4 7.588 7.4c1.69 0 3.512-.65 4.905-1.768 1.389-1.114 2.307-2.655 2.307-4.432a.6.6 0 1 1 1.2 0c0 2.223-1.154 4.082-2.756 5.368-1.596 1.282-3.68 2.032-5.656 2.032C4.348 17.6.4 13.763.4 9S4.348.4 9.188.4a8.847 8.847 0 0 1 6.753 3.097L16.41.894a.6.6 0 0 1 .697-.484Z",
    fill: "#187790"
  })));
};
export default SvgImageDucEditorResetMobile;